import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMe } from "@/hooks/use-auth";
import type { UserRole } from "@/lib/api-types";
import { AuthLoading } from "./auth-loading";

type Props = {
  roles: UserRole[];
  /** Where to send authenticated users whose role isn't allowed. */
  fallback?: string;
};

/**
 * Route guard: enforces both authentication AND role membership.
 * Not-signed-in → /login?next=…
 * Wrong role → /app (or provided fallback)
 */
export function RequireRole({ roles, fallback = "/app" }: Props) {
  const { data: me, isLoading } = useMe();
  const loc = useLocation();

  if (isLoading) return <AuthLoading />;
  if (!me) {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (!roles.includes(me.role)) return <Navigate to={fallback} replace />;
  return <Outlet />;
}
